import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";
import { RUTA_IMATGES, SERVICIOS } from '../Compartido/contenidoCamprodon.js';
import separarTitol from '../Compartido/separarTitol.js';
import CabeceraSeccion from './CabeceraSeccion.jsx';
import ControlesSlider from './ControlesSlider.jsx';

// "Serveis de l'Hotel Camprodon": icones amb línia vertical i nom en serif.
const Servicios = ({ textos, servicios }) => {

    const { t } = useTranslation();

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.c-service-item', SERVICIOS.length);

    const { titol, contingut } = useMemo(() => separarTitol(servicios?.ladesc), [servicios?.ladesc]);

    return (
        <section className="services o-container">
            <CabeceraSeccion antetitulo={textos.servicios.antetitulo} titulo={titol} texto={contingut} />
            <div className="c-services">
                <div className="c-services__slider" ref={trackRef}>
                    {SERVICIOS.map((servicio) => (
                        <div className="c-service-item position-relative d-flex-center" key={servicio.icono}>
                            <img className="c-service-item__icon" loading="lazy" decoding="async" alt="" src={RUTA_IMATGES + "serveis/" + servicio.icono} />
                            <div className="c-service-item__title text-center">{t(servicio.nombre)}</div>
                        </div>
                    ))}
                </div>
                <ControlesSlider
                    className="inline-center"
                    onPrev={() => scrollByCard(-1)}
                    onNext={() => scrollByCard(1)}
                    prevDisabled={navState.atStart}
                    nextDisabled={navState.atEnd}
                />
            </div>
        </section>
    );
};

export default Servicios;
